/**
 * 値がオブジェクトかどうかを判定する型ガード
 */
export function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/**
 * 値が文字列かどうかを判定する型ガード
 */
export function isString(value: unknown): value is string {
  return typeof value === "string";
}

/**
 * 値が数値かどうかを判定する型ガード
 */
export function isNumber(value: unknown): value is number {
  return typeof value === "number" && !Number.isNaN(value);
}

/**
 * 値がブール値かどうかを判定する型ガード
 */
export function isBoolean(value: unknown): value is boolean {
  return typeof value === "boolean";
}

/**
 * 値が配列かどうかを判定する型ガード
 */
export function isArray<T = unknown>(value: unknown): value is T[] {
  return Array.isArray(value);
}

/**
 * 値が日付かどうかを判定する型ガード
 */
export function isDate(value: unknown): value is Date {
  return value instanceof Date && !Number.isNaN(value.getTime());
}

/**
 * 値が定義されている（undefinedまたはnullでない）かどうかを判定する
 */
export function isDefined<T>(value: T | undefined | null): value is T {
  return value !== undefined && value !== null;
}

/**
 * 値がundefinedまたはnullかどうかを判定する型ガード
 */
export function isUndefined(value: unknown): value is undefined | null {
  return value === undefined || value === null;
}

/**
 * キーが指定されたオブジェクトに存在するかどうかを判定する
 */
export function hasKey<K extends string, T>(
  obj: Record<string, unknown>,
  key: K,
): obj is T & Record<K, unknown> {
  return isObject(obj) && key in obj;
}

/**
 * オブジェクトの形状を確認するためのヘルパー関数
 * 指定したキーと型が全て存在するかを確認します
 */
export function hasShape<T>(
  value: unknown,
  shape: Record<string, (v: unknown) => boolean>,
): value is T {
  if (!isObject(value)) {
    return false;
  }

  return Object.entries(shape).every(([key, validator]) => {
    return key in value && validator(value[key]);
  });
}
